<template>
	<main>
		<top v-show="$route.meta.showHeader" :showTopNav="$route.meta.showTopNav" />
		<keep-alive
			:include="[
				'home',
				'live',
				'Jengabet',
				'boosted-multibet',
				'casino',
				'casino-category',
				'my-bets',
			]"
		>
			<router-view />
		</keep-alive>
		<bottom v-show="$route.meta.showFooter" />
		<acca-on-mini-betslip
			v-if="
				!env.disabledFeatures.includes('accaBonus') &&
					['home', 'prebets-markets', 'live', 'live-markets'].includes(
						$route.name
					)
			"
		/>
		<mini-betslip v-if="showMiniBetslip" />
		<data-notifier />
	</main>
</template>

<script>
import Top from "../components/Shared/Top.vue";
import Bottom from "../components/Shared/Bottom.vue";
import MiniBetslip from "../components/Shared/MiniBetslip.vue";
import AccaOnMiniBetslip from "../components/Shared/AccaOnMiniBetslip.vue";
import DataNotifier from "../components/Shared/DataNotifier/index.vue";
export default {
	name: "mobile-layout",
	components: {
		Top,
		Bottom,
		MiniBetslip,
		AccaOnMiniBetslip,
		DataNotifier,
	},
	computed: {
		showMiniBetslip() {
			return this.$route.meta.miniBetslipViewable == true;
		},
	},
};
</script>

<style></style>
